import { render } from "./newhomepage.vue?vue&type=template&id=5ce3369e&scoped=true"
import script from "./newhomepage.vue?vue&type=script&lang=js"
export * from "./newhomepage.vue?vue&type=script&lang=js"

import "./newhomepage.vue?vue&type=style&index=0&id=5ce3369e&lang=css"
import "./newhomepage.vue?vue&type=style&index=1&id=5ce3369e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce3369e"]])

export default __exports__